
<template>
    <div>
        <div v-show="loading" class="alert alert-danger">
            <fa-icon icon="spinner" class="fa-spin me-2" />{{ text }}
        </div>
    </div>
</template>

<script lang="ts">

import { defineComponent } from "vue";

export default defineComponent({
    name: "Loading",
    props: {
        loading: {
            type: Boolean,
            default: false
        },
        text: {
            type: String,
            default: "Loading..."
        }
    }
});

</script>
